import {
  Box, Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  Paper,
  RadioGroup,
  Typography,
} from "@mui/material";
import { Colors } from "../../helpers/Consts";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ICompositionGroupItemList,
  ICompositionGroupList,
   IProduct, IProductFull,
} from "../../types/Product";
import { Fragment, useEffect } from "react";
import { QueryObserverResult, RefetchOptions, RefetchQueryFilters } from "react-query";


type Props = {
  open: boolean;
  handleClose: () => void;
  fullScreen:boolean;
  apiProductData: IProductFull;
  productDataRefetch: (options?: ((RefetchOptions & RefetchQueryFilters) | undefined)) => Promise<QueryObserverResult<IProductFull, unknown>>
  product: IProduct
};

/**
 * CARDÁPIO: aqui é só para exibir detalhes, mas sem deixar usuário adicionar produtos
 * na sacola.
 * @param apiProductData
 * @param productDataRefetch
 * @param product
 * @param open
 * @param handleClose
 * @param fullScreen
 * @constructor
 */
export default function FoodDialogForm({apiProductData, productDataRefetch, product, open, handleClose, fullScreen}: Props){
  const productData = apiProductData.data;

  function emReal(valor: number): string {
    return valor.toLocaleString("pt-br", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    })
  }

  useEffect(() => {
    return ()=>{productDataRefetch()}
  }, []);


  return(<Dialog
    fullScreen={fullScreen}
    open={open}
    onClose={() => {
      handleClose();
    }}
    maxWidth={"lg"}
  >
    <DialogTitle color={Colors.orangePrimary}>
      <Box display="flex" alignItems="center">
        <Box>
          <IconButton
            color="primary"
            onClick={async () => {
              handleClose();
            }}
          >
            <ArrowBackIosIcon fill={Colors.orangePrimary} />
          </IconButton>
        </Box>
        <Box
          flexGrow={1}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          Detalhes do Item
        </Box>
      </Box>
    </DialogTitle>
    <DialogContent>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          width: { md: "600px" },
          height: "100%",
        }}
      >
        <Box display="flex" alignItems="center" justifyContent="center">
          {productData?.image ? (
            <Box
              component="img"
              sx={{
                borderRadius: "7px",
                width: {
                  xs: "180px",
                  sm: "200px",
                  md: "280px",
                },
                height: {
                  xs: "180px",
                  sm: "200px",
                  md: "280px",
                },
              }}
              src={productData?.image}
              alt={productData?.name}
            />
          ) : (
            <Box
              component="img"
              sx={{
                borderRadius: "7px",
                width: {
                  xs: "180px",
                  sm: "200px",
                  md: "280px",
                },
                height: {
                  xs: "180px",
                  sm: "200px",
                  md: "280px",
                },
              }}
              src={require("assets/img/noImageProduct.png")}
              alt={productData?.name}
            />
          )}
        </Box>
        <Box marginTop={2}>
          <Typography
            fontSize="16px"
            fontWeight={"700"}
            color={Colors.grayTextColorDarkestDark}
          >
            {productData?.name}
          </Typography>
          <Typography
            fontSize="12px"
            color={Colors.baseTextColor}
            marginTop="4px"
          >
            {productData?.description}
          </Typography>

          {product?.show_people_served_information ? (<Typography
            fontSize="10px"
            color={Colors.baseTextColor}
            marginTop="2px"
          >
            Serve até {productData?.people_served} pessoa(s)
          </Typography>) : null}
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Typography
              color="green"
              style={{
                fontWeight: 700,
                fontSize: "20px",
                marginTop: "12px",
              }}
            >
              {product?.new_price.toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </Typography>
            {product.old_price > product.new_price && (
              <Typography
                color={Colors.grayTextColorDark}
                style={{
                  fontWeight: 400,
                  fontSize: "20px",
                  marginTop: "12px",
                  marginLeft: "5px",
                  textDecoration: "line-through",
                }}
              >
                {product?.old_price.toLocaleString("pt-br", {
                  style: "currency",
                  currency: "BRL",
                })}
              </Typography>
            )}
          </Box>
          <Box>
            {/* CATEGORIAS DE SUBITENS ********************************************************************/}
            {productData?.compositionGroupList.map(
              (category: ICompositionGroupList) => (
                <Fragment key={category.id}>
                  <Box
                    sx={{
                      padding: '5px',
                      backgroundColor: 'lightGray',
                      display: "flex",
                    }}
                  >
                    <Box>
                      <Typography
                        style={{
                          fontWeight: 700,
                          fontSize: "13px",
                        }}
                      >
                        {category.description}
                      </Typography>

                      <Typography
                        color={Colors.baseTextColor}
                        style={{
                          fontWeight: 400,
                          fontSize: "12px",
                        }}
                      >
                        {(category.max <= 1 ? '' : `até ${category.max}`)}
                      </Typography>
                    </Box>
                    <Box flexGrow={1} />
                    <Box>
                      <Paper
                          sx={{
                            paddingX: "4px",
                            paddingY: "4px",
                            minWidth: "58.77px",
                            backgroundColor: category.mandatory
                              ? "red"
                              : Colors.grayTextColorDark,
                            textAlign: "center",
                          }}
                          variant="elevation"
                          elevation={3}
                        >
                          <Typography fontSize={"10px"} color="white">
                            {category.mandatory
                              ? "Obrigatório"
                              : "Opcional"}
                          </Typography>
                        </Paper>
                    </Box>
                  </Box>
                  <FormControl fullWidth>
                    <RadioGroup
                      name={category.description + category.id}
                    >
                      {/* SUBITENS ********************************************************************/}
                      {productData?.compositionGroupItemList
                        .filter( (itens: ICompositionGroupItemList) =>
                            itens.product_composition_id === category.id
                        )
                        .map((item: ICompositionGroupItemList, index: number) => (
                          <Box
                            sx={{
                              marginBottom: "8px",
                              display: "flex",
                              alignItems: "center",
                              backgroundColor: index % 2 === 0 ? 'none' : "#f9f4f4",
                            }}
                            key={item.id}
                          >
                            <Box>
                              <Typography
                                style={{
                                  paddingLeft: "8px",
                                  fontWeight: 400,
                                  fontSize: "12px",
                                }}
                              >
                                {item.name}
                              </Typography>
                              <Typography
                                color={Colors.baseTextColor}
                                style={{
                                  paddingLeft: "8px",
                                  fontWeight: 400,
                                  fontSize: "11px",
                                }}
                              >
                                {emReal(item.price)}
                              </Typography>
                            </Box>
                            <Box flexGrow={1} />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                            </Box>
                          </Box>
                        ))}
                    </RadioGroup>
                  </FormControl>
                </Fragment>
              )
            )}
          </Box>
        </Box>
      </Box>
    </DialogContent>
  </Dialog>)
}